/**
 * View modes reducer
 * Holds active view modes for various components
 */

import * as actionTypes from "../actions/actionTypes";
import * as inspectorModes from "../constants/inspectorModes";
import * as galleryAssetViewModes from "../constants/galleryAssetViewModes";

const inspectorPreference =
  localStorage.getItem("lingo_inspector_preference") || inspectorModes.SIMPLE;
const galleryAssetModePreference =
  localStorage.getItem("lingo_gallery_asset_view_preference") || galleryAssetViewModes.DETAILED;

export default function viewModes(
  state = { inspectorMode: inspectorPreference, galleryAssetViewMode: galleryAssetModePreference },
  action
) {
  switch (action.type) {
    case actionTypes.CHANGE_INSPECTOR_VIEW_MODE:
      return { ...state, inspectorMode: action.mode };
    case actionTypes.CHANGE_GALLERY_ASSET_VIEW_MODE:
      return { ...state, galleryAssetViewMode: action.mode };
    default:
      return state;
  }
}
